"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayFlattenEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const dto_1 = require("../../../dto");
const types_1 = require("../../../types");
const display_group_entity_1 = require("./display-group.entity");
/**
 * Flattened display entity for optimized API responses
 * with essential display information and reduced nested structure
 */
class DisplayFlattenEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    name;
    description;
    categoryId;
    tags;
    categoryCircuitIds;
    /**
     * @deprecated
     */
    ds;
    isMy;
    autoaccept_media;
    medias;
    /**
     * @deprecated
     */
    profile_picture;
    url_streetview;
    address_details;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    group;
    audience_stats;
    pricing;
    ad_policies;
    ownerCampaignSlotsPaidQuantity;
    ownerCampaignSlotsPendingQuantity;
    ownerCampaignSlotsPendingDelta;
    ownerCampaignSlotsPendingUntil;
    slug;
    ownerId;
    providerId;
    display_time_zone;
    metadata;
    schedule;
    opacity_schedule;
    standard_price;
    standard_currency;
    platform_provider;
    /**
     * @deprecated
     */
    is_live;
    send_restriction;
    private_only;
    is_archived;
    is_on;
    media_types;
    visible;
    last_connection_at;
    connected_since_at;
    restricted_send;
    interior;
    external;
    last_context_update;
    contextual_data;
    createdAt;
    updatedAt;
}
exports.DisplayFlattenEntity = DisplayFlattenEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Legacy (deprecated)",
        deprecated: true,
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the display",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Human-readable name of the display",
        example: "Times Square Billboard",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Detailed description of the display",
        example: "Large LED billboard located in Times Square, New York",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "description", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display category identifier",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "categoryId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Tags associated with the display",
        type: [String],
        example: ["507f1f77bcf86cd799439011"],
    }),
    __metadata("design:type", Array)
], DisplayFlattenEntity.prototype, "tags", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Category circuit ids this display belongs to",
        type: [String],
        example: ["507f1f77bcf86cd799439011"],
    }),
    __metadata("design:type", Array)
], DisplayFlattenEntity.prototype, "categoryCircuitIds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Digital signage flag",
        example: true,
        deprecated: true,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "ds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this display belongs to the current user",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "isMy", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether media is automatically accepted without approval",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "autoaccept_media", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of media files associated with the display",
        type: "array",
        items: {
            type: "object",
            properties: {
                url: { type: "string", example: "https://example.com/media.jpg" },
                type: { type: "string", enum: ["image", "video"], example: "image" },
            },
        },
    }),
    __metadata("design:type", Array)
], DisplayFlattenEntity.prototype, "medias", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Profile picture URL (deprecated)",
        deprecated: true,
        example: "https://example.com/profile.jpg",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "profile_picture", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Google Street View URL for the display location",
        example: "https://maps.google.com/streetview?cbll=40.7589,-73.9851",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "url_streetview", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Structured postal address for display onboarding",
        type: "object",
        properties: {
            address_line_1: { type: "string", example: "Calle Mayor 1" },
            address_line_2: { type: "string", example: "Floor 2" },
            postal_code: { type: "string", example: "28013" },
            city: { type: "string", example: "Madrid" },
            state_region: { type: "string", example: "Madrid" },
            country: { type: "string", example: "ES" },
        },
    }),
    __metadata("design:type", Object)
], DisplayFlattenEntity.prototype, "address_details", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Deprecated audience fallback used only when daily audience is unavailable",
        deprecated: true,
        type: "object",
        properties: {
            min: { type: "number", example: 1000 },
            max: { type: "number", example: 5000 },
            average: { type: "number", example: 3000 },
        },
    })
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", Object)
], DisplayFlattenEntity.prototype, "approximateDailyImpressions", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display group entity if the display belongs to a group",
        type: display_group_entity_1.DisplayGroupEntity,
    }),
    __metadata("design:type", display_group_entity_1.DisplayGroupEntity)
], DisplayFlattenEntity.prototype, "group", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Audience statistics for the display",
        type: "array",
        items: {
            type: "object",
            properties: {
                day_of_week: { type: "number", example: 1 },
                hours: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            start: { type: "number", example: 28800 },
                            end: { type: "number", example: 36000 },
                            count: { type: "number", example: 2500 },
                        },
                    },
                },
                daily_total: { type: "number", example: 15000 },
            },
        },
    }),
    __metadata("design:type", Array)
], DisplayFlattenEntity.prototype, "audience_stats", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Pricing details for the display",
        type: dto_1.DisplayPricingDto,
    }),
    __metadata("design:type", Object)
], DisplayFlattenEntity.prototype, "pricing", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Advertising policies for the display",
    }),
    __metadata("design:type", Object)
], DisplayFlattenEntity.prototype, "ad_policies", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Paid owner-campaign slot quantity active for the current period",
        default: 0,
        minimum: 0,
        example: 2,
    }),
    __metadata("design:type", Number)
], DisplayFlattenEntity.prototype, "ownerCampaignSlotsPaidQuantity", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Pending owner-campaign slot quantity that will replace the active paid quantity at the next period",
        default: 0,
        minimum: 0,
        example: 1,
    }),
    __metadata("design:type", Number)
], DisplayFlattenEntity.prototype, "ownerCampaignSlotsPendingQuantity", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Delta for owner-campaign slots pending to apply at the scheduled date. Negative means cancel, positive means add.",
        example: -2,
    }),
    __metadata("design:type", Number)
], DisplayFlattenEntity.prototype, "ownerCampaignSlotsPendingDelta", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Date when the pending owner-campaign slot quantity takes effect",
        type: Date,
    }),
    __metadata("design:type", Date)
], DisplayFlattenEntity.prototype, "ownerCampaignSlotsPendingUntil", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "URL slug for the display",
        example: "times-square-billboard",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "slug", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display owner user identifier",
        example: "user_owner_123",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "ownerId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display provider user identifier",
        example: "user_provider_456",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "providerId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display timezone",
        example: "America/New_York",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "display_time_zone", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display metadata including location and technical specifications",
    }),
    __metadata("design:type", Function)
], DisplayFlattenEntity.prototype, "metadata", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display schedule configuration",
    }),
    __metadata("design:type", Function)
], DisplayFlattenEntity.prototype, "schedule", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display opacity schedule configuration",
        type: types_1.DisplayOpacitySchedule,
    }),
    __metadata("design:type", types_1.DisplayOpacitySchedule)
], DisplayFlattenEntity.prototype, "opacity_schedule", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Standard price for content display",
        example: 10.99,
    }),
    __metadata("design:type", Number)
], DisplayFlattenEntity.prototype, "standard_price", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Currency for standard pricing",
        example: "EUR",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "standard_currency", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Service platform provider of the display device",
        example: "Broadsign",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "platform_provider", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether the display is live (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "is_live", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Restriction on sending content to the display",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "send_restriction", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is private only",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "private_only", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is archived",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "is_archived", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is currently on/active",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "is_on", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Supported media types for the display",
        type: "array",
        items: { type: "string" },
        example: ["image", "video", "gif"],
    }),
    __metadata("design:type", Array)
], DisplayFlattenEntity.prototype, "media_types", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is visible",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "visible", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last connection timestamp",
        type: "string",
        format: "date-time",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", Date)
], DisplayFlattenEntity.prototype, "last_connection_at", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Timestamp when the current online session started",
        type: "string",
        format: "date-time",
        nullable: true,
    }),
    __metadata("design:type", Object)
], DisplayFlattenEntity.prototype, "connected_since_at", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether sending content to the display is restricted",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "restricted_send", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is located indoors",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "interior", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is located outdoors",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayFlattenEntity.prototype, "external", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Timestamp of the last contextual data update",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", Object)
], DisplayFlattenEntity.prototype, "last_context_update", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Contextual data related to the display",
        type: "object",
        properties: {
            scoring: {
                type: "object",
                properties: {
                    total_score: { type: "number", example: 85 },
                    commercial_score: { type: "number", example: 90 },
                    transit_score: { type: "number", example: 80 },
                    last_calculated: { type: "string", format: "date-time", example: "2024-01-15T10:30:00Z" },
                },
            },
            services: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        name: { type: "string", example: "Coffee Shop" },
                        category: { type: "string", example: "catering" },
                        distance_meters: { type: "number", example: 150 },
                    },
                },
            },
        },
    }),
    __metadata("design:type", Object)
], DisplayFlattenEntity.prototype, "contextual_data", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Creation timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last update timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayFlattenEntity.prototype, "updatedAt", void 0);
